import { LoadButton, NoDataMessage, isNoData } from '../shared';
import { AuctionIcon } from '../icons';
import { AuctionRecordCard } from '../cards/AuctionRecordCard';
import type { UseQueryResult } from '@tanstack/react-query';

interface AuctionTabProps {
  query: UseQueryResult<any>;
  loadEnabled: boolean;
  onLoad: () => void;
  disabled?: boolean;
}

export function AuctionTab({ query, loadEnabled, onLoad, disabled }: AuctionTabProps) {
  return (
    <div>
      {!loadEnabled && (
        <div className="flex flex-col items-center justify-center py-12">
          <AuctionIcon className="w-12 h-12 opacity-40 mb-4" />
          <p className="text-gray-400 text-sm mb-4">Search auction records with photos, specs, and sale details</p>
          <LoadButton label="Load Auction History" onClick={onLoad} isLoading={false} isLoaded={false} disabled={disabled} />
        </div>
      )}

      {query.isLoading && (
        <p className="text-gray-500 text-sm text-center py-8">Loading auction history...</p>
      )}

      {query.error && !isNoData(query) && (
        <p className="text-red-400 text-sm text-center py-4">Error loading auction data</p>
      )}

      {isNoData(query) && (
        <NoDataMessage message="No auction records found for this vehicle" />
      )}

      {query.data?.data && Array.isArray(query.data.data) && !isNoData(query) && (
        <div className="space-y-4">
          {query.data.data.length > 0 ? (
            query.data.data.map((record: any, idx: number) => (
              <AuctionRecordCard key={idx} record={record} />
            ))
          ) : (
            <NoDataMessage message="No auction history found for this vehicle" />
          )}
        </div>
      )}
    </div>
  );
}
